/**
 * Application configuration module.
 * This is a separate module to avoid circular dependencies.
 */

export interface AppConfig {
  apiEndpoint: string;
  webSocketEndpoint?: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain?: string;
  oktaAutoRedirect?: boolean;
  env: string;
  sftpEndpoint?: string;
}

// Global config - set by App.tsx during initialization
export let appConfig: AppConfig | null = null;

// Setter function for App.tsx to use
export const setAppConfig = (config: AppConfig) => {
  appConfig = config;
};

/**
 * Normalize a raw env string (dev/tst/np/prd/sbx, any case) into a short
 * uppercase display label (DEV/TST/NP/PRD/SBX). Returns null when env is
 * absent so callers can degrade gracefully in local dev.
 */
export const getEnvLabel = (env?: string | null): string | null => {
  if (!env) return null;
  const normalized = env.toLowerCase().trim();
  if (!normalized) return null;
  return normalized.toUpperCase();
};
